import { useEffect } from "react";
import { useBlocker } from "@tanstack/react-router";
import { useDialog } from "@/hooks/useDialog";

const useNavigationBlocker = (shouldBlock: boolean) => {
  const { openDialog, closeDialog } = useDialog();
  const { proceed, reset, status } = useBlocker({
    shouldBlockFn: () => shouldBlock,
    withResolver: true,
    enableBeforeUnload: shouldBlock,
  });

  useEffect(() => {
    if (status === "blocked") {
      openDialog({
        title: "即將離開南一 AI 素養出題",
        content: "離開後所有內容將不會保留，請再次確認是否要離開",
        confirmText: "離開",
        cancelText: "取消",
        onConfirm: () => proceed(),
        onCancel: () => reset(),
        isShowCloseIcon: false,
      });
    }

    return () => {
      if (status === "blocked") {
        closeDialog();
      }
    };
  }, [status, openDialog, closeDialog, proceed, reset]);
};

export default useNavigationBlocker;
